import { Spinner as ChakraSpinner } from '@chakra-ui/react';

export const Spinner = ChakraSpinner;
